import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import React from 'react';

function AtBodyItem(props) {
  return (
    <div key={props.keyValue}>
      <div>
        {props.val.heading && (
          <div className="my-trips-title">
            <span>{props.val.heading}</span>
          </div>
        )}

        <div className="kupos-card my-trips-item font9">
          <div className="display-flex">
            <div style={{ width: '80%' }}>
              <div className="my-trips-sub-item less-bold-text font11">
                {CommonService.normalizeAddress(
                  props.val.txn_subtype === 'TO_AIRPORT'
                    ? props.val.user_boading_address
                    : props.val.origin_loc_name,
                ) +
                  ' - ' +
                  CommonService.normalizeAddress(
                    props.val.txn_subtype === 'FROM_AIRPORT'
                      ? props.val.user_boading_address
                      : props.val.destination_loc_name,
                  )}
              </div>
              <span className="individual-line font9">
                {DateService.changeDateFormat(props.val.trip_ref_date, 'yyyy-mm-dd', 'dd/mm/yyyy')}
                {/* {DateService.getMyTripsDateFormat(val.travel_date)} */}
              </span>
              <br />
              <span className="individual-line font9">
                {props.t('PROFILE.STATUS')}: {props.t('STATUS.' + props.val.status)}
              </span>
            </div>

            <div className="right-section-trips-item">
              <div className="float-right">
                <div
                  className="primary-text less-bold-text see-more-trip-details"
                  onClick={() => props.onSeeMoreClickedAT(props.val, props.keyValue)}
                >
                  {props.t('PROFILE.VIEW_MORE')}
                  <span className="sub-section-my-trips-strip-arrow-icon">
                    <img src="/images/icons/home/icon_arrow_down.png" alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          'sub-body-my-trips font10 ' +
          'light-grey-text ' +
          (props.keyValue == props.selectedTripItem ? 'show' : 'hide')
        }
      >
        {console.log('Selected At ticket', props.ticketDetailsAt)}
        {!props.busTicketLoading && props.ticketDetailsAt ? (
          <div>
            <span className="sub-body-my-trips-title primary-text-color bold-text font10">
              {props.t('PROFILE.TRIP_DETAIL')}
            </span>
            <div className="sub-body-sub-item ">
              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRAVEL_DATE')}</span> <br />
                  <span className="font10">
                    {DateService.changeDateFormat(
                      props.ticketDetailsAt.trip_ref_date,
                      'yyyy-mm-dd',
                      'dd/mm/yyyy',
                    )}
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRAVEL_TIME')}</span> <br />
                  <span className="font10">
                    {DateService.ampm(props.ticketDetailsAt.trip_ref_time)}
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRANSACTION_NUMBER')}</span>{' '}
                  <br />
                  <span className="font10">{props.ticketDetailsAt.pnr_id}</span>
                </div>
              </div>
            </div>
            <hr className="horizontal-line" />
            <div>
              <span className="bold-text font10">{props.t('PROFILE.DEPARTURE_POINT')}</span>
              <ul className="sub-item-list font10">
                <li>
                  {CommonService.normalizeAddress(
                    props.ticketDetailsAt.txn_subtype === 'TO_AIRPORT'
                      ? props.ticketDetailsAt.user_boading_address
                      : props.data.metaData &&
                          props.data.metaData.airport_transfer &&
                          props.data.metaData.airport_transfer.at_locations &&
                          props.data.metaData.airport_transfer.at_locations[0] &&
                          props.data.metaData.airport_transfer.at_locations[0].address,
                  )}
                  {/* -{' '}
                        {DateService.ampm(state.ticketDetailsAt.travel_time)} */}
                </li>
              </ul>
              <span className="bold-text font10">{props.t('PROFILE.ARRIVAL_POINT')}</span>
              <ul className="sub-item-list font10">
                <li>
                  {CommonService.normalizeAddress(
                    props.ticketDetailsAt.txn_subtype === 'FROM_AIRPORT'
                      ? props.ticketDetailsAt.user_boading_address
                      : props.data.metaData &&
                          props.data.metaData.airport_transfer &&
                          props.data.metaData.airport_transfer.at_locations &&
                          props.data.metaData.airport_transfer.at_locations[0] &&
                          props.data.metaData.airport_transfer.at_locations[0].address,
                  )}
                </li>
              </ul>

              <div className="sub-body-sub-item">
                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.COMPANY')}: {props.ticketDetailsAt.service_provider}
                    </span>
                  </div>
                </div>

                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.SEATS')}: {props.ticketDetailsAt.no_of_seats}
                    </span>
                  </div>
                </div>

                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.TOTAL_PRICE')}:{' '}
                      {CommonService.currency(props.ticketDetailsAt.total_amount)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr className="horizontal-line" />
            <div className="sub-body-sub-item">
              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.STATUS')}</span> <br />
                  <span className="font10">
                    {props.t('STATUS.' + props.ticketDetailsAt.status)}
                  </span>
                </div>
              </div>

              <div>
                {props.ticketDetailsAt &&
                (props.ticketDetailsAt.status.toUpperCase() != 'CANCELLED' ||
                  props.ticketDetailsAt.status.toUpperCase().indexOf('PARTIAL') > -1) &&
                props.notIspast(props.ticketDetailsAt.travel_date) ? (
                  <div className="cancelation-conformation-box">
                    <button
                      className="kupos-button font10"
                      onClick={() => props.cancelBusTicket(props.ticketDetailsAt, 'at')}
                    >
                      {props.busTicketCancellationLoading ? (
                        <div className="loader-cricle"></div>
                      ) : (
                        <span>{props.t('PROFILE.CANCEL_TRIP')}</span>
                      )}
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <div className="loading-bus-ticket-details">{props.t('CANCEL_TICKET.LOADING')}</div>
        )}
      </div>
    </div>
  );
}

export default AtBodyItem;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyTrips/components/ATBodyItem.js